import React from 'react'
import ContentLoader from 'react-content-loader'

const CardShim = () => (
  <ContentLoader
    foregroundColor="rgb(0,0,0)"
    backgroundColor="rgb(0,0,0)"
    foregroundOpacity={0.06}
    backgroundOpacity={0.12}
    preserveAspectRatio="none"
  >
    <rect width={'100%'} rx="8" ry="8" />
  </ContentLoader>
)

export default CardShim
